import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Box,
  Button,
  IconButton,
  TextField,
  Grid,
  CircularProgress,
  Modal,
  Card,
  CardHeader,
  CardContent,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import Controls from "../../atoms/Controls";
import { getKvnrError } from "../../utils/kvnrValidator";
import EditTable, { validateFrequency, validateTherapy } from "../../molecules/Editable";
import { rxuseForm, useForm } from "./Form";
import { PatientsContext } from "../../stores/Patients/patients.provider";
import useStore from "../../helpers/useStore";
import { v4 as uuidv4 } from "uuid";
import { RxDto } from "../../api-client";
import { DoctorContext } from "../../stores/Doctor/doctor.provider";
import DoctorDialog from "./Doctor";
import { useMasterTables, useIcdCodes, resolveTarifGroupForRxType } from "../../stores/MasterTables";
import { format, parseISO } from "date-fns";
import { observer } from "mobx-react";
import WarningDialog from "../../atoms/WarningDialog";
import DoctorClinicJoinConfirmDialog from "../DoctorManagement/DoctorClinicJoinConfirmDialog";
import DoctorClinicMismatchDialog from "../DoctorManagement/DoctorClinicMismatchDialog";
import { UserContext } from "../../stores/User/User.provider";
import { useUserAccounts } from "../../stores/User/User.hooks";
import { observe, toJS } from "mobx";
import notificationStore from "../../stores/Notification/notificationStore";
import { confirmDoctorClinicJoin } from "../DoctorManagement/confirmDoctorClinicJoin";
import { confirmDoctorClinicMismatch } from "../DoctorManagement/confirmDoctorClinicMismatch";
import { TopLevelPaper } from "../../themes/StyledComponents";
import FlatCard from "../../atoms/FlatCard";
import Private from "../PatientOverview/RxInfo/RxForms/Private/Private";
import BG from "../PatientOverview/RxInfo/RxForms/BG/BG";
import Verordnung13 from "../PatientOverview/RxInfo/RxForms/Kasse/Verordnung13";
import Bundeswehr from "../PatientOverview/RxInfo/RxForms/Bundeswehr/Bundeswehr";
import Zahnarzt from "../PatientOverview/RxInfo/RxForms/Zahnarzt/Zahnarzt";
import Blankoverordnung from "../PatientOverview/RxInfo/RxForms/Blankoverordnung/Blankoverordnung";
import { Delete } from "@mui/icons-material";
import { ClinicForModal, Doctor } from "../DoctorManagement/DoctorTabContent/doctor-client-types";
import VerordnungDialog from "../PatientOverview/RxInfo/RxForms/Kasse/VerordnungDialog";
import DoctorCard from "../../molecules/DoctorCard";
import { visitTypeMapping } from "../../helpers/visitTypeMapping";
import { useSaveRxs } from "../../stores/Rx/rx.mutations";
import { usePrescribedTherapyOptions } from "../../stores/MasterTables/masterTables.queries";
import { handleParseInput } from "../../helpers/parseInput";
import { rowNamesTerm, rowTermText } from "../../helpers/rxFormRow";
import moment from "moment";
import { PASSIVE_ABBREVIATIONS_AT_ENTRY } from "../../helpers/slotTherapy";
import { therapyRxEditValue } from "../../helpers/therapyRxLabel";
import type { RowData } from "../../molecules/Editable";

interface ReceiptDataEntryDialogProps {
  isEditing?: boolean;
  openDialog: boolean;
  handleCloseDialog: () => void;
  // handleSubmit: () => void;
  selectedRow?: any; // Adjust the type of selectedRow accordingly
  patientValues: any;
  handleData?: any;
  additionalRx?: boolean;
  patientForm?: boolean;
  rxTableDataChange?: (data: any) => void;
}

export enum EntryType {
  newRx = "newRx",
  additionalRx = "additionalRx",
}
interface DiagnoseGroup {
  a: string;
  b: string;
  c: string;
  d: string;
}

const ReceiptDataEntryDialog: React.FC<ReceiptDataEntryDialogProps> = observer(
  ({
    isEditing,
    openDialog,
    handleCloseDialog,
    // handleSubmit,
    selectedRow,
    patientValues,
    handleData,
    patientForm,
    rxTableDataChange
  }) => {
    // console.log("SelectedrtteRow", selectedRow, patientValues, handleData);
    const [therapytableData, settherapyTableData] = useState([]);
    const [rxtableData, setrxTableData] = useState<any>([]);
    const [selectedLANR, setSelectedLANR] = useState<string | null>(null);
    const [selectedBSNR, setSelectedBSNR] = useState<string | null>(null);
    const [selectedChipCard, setSelectedChipCard] = useState<string | null>(null);
    const [selectedPayer, setSelectedPayer] = useState(null);
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const DoctorStore = useStore(DoctorContext);
    const { getClinicById, getDoctorById, createDoctorWithClinic } = DoctorStore;
    const UserStore = useStore(UserContext);
    const { user } = UserStore;
    const accounts = useUserAccounts();
    const { data: masterTablesData } = useMasterTables();

    const { mutate: patientSaveRxs } = useSaveRxs();
    // Prescribed TERMS — the catalog level a prescription names (MD-232).
    const { data: termOptions = [] } = usePrescribedTherapyOptions();
    const safeMasterData = masterTablesData || [];
    const patientStore = useStore(PatientsContext);
    const [formChanged, setFormChanged] = useState(false);
    // const [doctorOptions, setDoctorOptions] = useState([]);
    const [fetchedData, setFetchedData] = useState(null);
    const [showWarning, setShowWarning] = useState(false);
    const [selectedDiagnoseGroup, setSelectedDiagnoseGroup] = useState<DiagnoseGroup | null>(null);
    // console.log("DIAGNOSETH", selectedDiagnoseGroup, selectedDiagnoseGroup?.c);
    const [loading, setLoading] = useState(false);

    const [isAddEditDialogOpen, setAddEditDialogOpen] = useState(false);

    // const [isDoctorNumberDisabled, setIsDoctorNumberDisabled] = useState(true);
    const [doesClinicExist, setDoesClinicExist] = useState(false);
    const [isClinicModalOpen, setIsClinicModalOpen] = useState(false);
    const [currentClinicId, setCurrentClinicId] = useState("");
    const [currentICD, setCurrentICD] = useState(null)
    const { data: icdObject } = useIcdCodes(currentICD,false);
    const [creationResponse, setCreationResponse] = useState({
      id: "",
      clinics: [],
      contactInfo: {},
      doctorId: "",
      clinicId: "",
    });
    const [currentDoctorId, setCurrentDoctorId] = useState("");
    const [doesDoctorExist, setDoesDoctorExist] = useState(false);
    const [currentClinic, setCurrentClinic] = useState<ClinicForModal | undefined>(
      selectedRow?.clinic
    );
    const [showClinicData, setShowClinicData] = useState(false);
    const [currentDoctor, setCurrentDoctor] = useState<Doctor | ClinicForModal>();

    // const handleOpenAddEditDialog = () => {
    //   setAddEditDialogOpen(true);
    // };
    const handleOpenAddEditDialog = (lanr: string | null, bsnr: string | null) => {
      setSelectedLANR(lanr);
      setSelectedBSNR(bsnr);
      setAddEditDialogOpen(true);
    };

    const handleCloseWarning = () => {
      setShowWarning(false);
    };

    const [columnSets, setColumnSets] = useState<any[]>([]);
    const handleAddColumnSet = () => {
      const newColumnSet = generateColumnSet(columnSets.length + 1);
      setColumnSets((prevColumnSets) => [...prevColumnSets, newColumnSet]);
    };

    // Function to generate a new column set
    const generateColumnSet = (columnIndex: any) => [
      {
        field: `therapy${columnIndex}`,
        headerName: `Heilmittel ${columnIndex}`,
        editable: true,
      },
      {
        field: `amount${columnIndex}`,
        headerName: `Menge ${columnIndex}`,
        editable: true,
      },
      {
        field: `frequency${columnIndex}`,
        headerName: `Frequency ${columnIndex}`,
        editable: true,
      },
    ];

    const onTableDataChange = (data: any) => {
      // console.log("Data", data);

      const updatedRxs = data.map((rx: any) => {
        if (rx.visitType && visitTypeMapping.hasOwnProperty(rx.visitType)) {
          rx.visitType = visitTypeMapping[rx.visitType];
        }
        if (rx.visitType) {
          // Set isHomeVisit based on visitType
          if (rx.visitType === "Haus" || rx.visitType === "Heim") {
            rx.isHomeVisit = true;
          } else if (rx.visitType === "Praxis") {
            rx.isHomeVisit = false;
          } else {
            rx.isHomeVisit = null; // Set to null if it's neither Haus nor Praxis
          }
        }
        const existingRxIndex = patientValues?.rxs?.findIndex(
          (existingRx: any) => existingRx.id === rx.id
        );

        // const newRowAdded = Math.abs(
        //   rx.therapies?.length - columnSets.length - 1
        // );
        // console.log('ZUi',newRowAdded,rx.therapies?.length,columnSets.length)

        // // Add new column sets if needed
        // const newColumnSets = Array.from({ length: newRowAdded }, (_, index) =>
        //   generateColumnSet(columnSets.length + index + 1)
        // );
        // setColumnSets((prevColumnSets) => [...prevColumnSets, ...newColumnSets]);

        const therapyRxs: any[] = [];

        if (rx.rxtype || rx.therapyRxs) {
          // console.log("ZUUJJJSJJSJ", rx, rxtableData);
          // const rxs = {
          //   rxNumber: rx.rxNumber,
          //   id: rx.id,
          //   date: rx.date,
          //   number: rx.therapies[0]?.amount,
          //   therapy: rx.therapies[0]?.therapy?.abbreviation,
          //   therapyId: rx.therapies[0]?.id,
          //   frequency:rx.therapies[0]?.frequency

          // };
          // setrxTableData([rxs] as any)
          const rxs: any = {
            rxNumber: rx.rxNumber,
            id: rx.id,
            creationDate: rx.creationDate,
            isHomeVisit: rx.isHomeVisit,
            // date: rx.date,
            amount: rx.amount,
            therapy: rx.therapy,
            therapyId: rx.therapyId,
            frequency: rx.frequency,
          };
          //   number: rx.therapies[0]?.amount,
          //   therapy: rx.therapies[0]?.therapy?.abbreviation,
          //   therapyId: rx.therapies[0]?.id,
          //   frequency:rx.therapies[0]?.frequency

          rx.therapyRxs.forEach((therapy: any, index: any) => {
            if (index === 0) {
              // For the first therapy, use the existing fields
              rxs.therapyId = therapy.id;
              rxs.amount = therapy.amount;
              rxs.therapy = therapy.therapy?.abbreviation || therapy.therapy;
              rxs.frequency = therapy.frequency?.text || therapy.frequency;
            } else {
              // For subsequent therapies, add index to the field names
              rxs[`therapyId${index}`] = therapy.id;
              rxs[`amount${index}`] = therapy.amount;
              rxs[`therapy${index}`] = therapy.therapy?.abbreviation || therapy.therapy;
              rxs[`frequency${index}`] = therapy.frequency?.text || therapy.frequency;
            }
          });
          // rxs.location=rx.location
          // console.log("Rx112", rxtableData);
          // Set the rxTableData with the newly constructed rxs array
          // setrxTableData((prevRxTableData:any) => {
          //   const updatedRxTableData = [...prevRxTableData, rxs];
          //   console.log('Updated Rx Table Data:', updatedRxTableData);
          //   return updatedRxTableData;
          // });
          setrxTableData((prevRxTableData: any) => {
            const updatedRxTableData = [...prevRxTableData];
            const existingIndex = updatedRxTableData.findIndex((item) => item.id === rxs.id);

            if (existingIndex !== -1) {
              updatedRxTableData[existingIndex] = rxs;
            } else {
              updatedRxTableData.push(rxs);
            }

            // console.log("Updated Rx Table Data:", updatedRxTableData);
            return updatedRxTableData;
          });
          // setrxTableData([...rxtableData, rxs] as any);
          // console.log("Rx", rxtableData, rxs);
          return rx;
        }
        // console.log("Thzuuuu");
        for (const key in rx) {
          if (rx.hasOwnProperty(key) && key.startsWith("therapy") && !key.startsWith("therapyId")) {
            const index = key.slice(key.indexOf("y") + 1);
            const therapyNumber = rx[`amount${index}`] || "";
            const therapy = rx[`therapy${index}`] || "";
            const frequency = rx[`frequency${index}`] || "";
            const therapyId = rx[`therapyId${index}`] || "";

            // Check if therapy data exists before adding
            if (therapyNumber || therapy || frequency) {
              // MD-232: a line names the prescribed TERM as the text that was
              // typed; the server resolves it text -> alias -> term on save.
              // Without `rawText` the line reaches the server naming no term at
              // all and it answers, correctly but opaquely, that the Heilmittel
              // "unbekannt" cannot be mapped into the tarif group. `therapy` is
              // kept because the table's own cells still read it.
              //
              // No client uuid for a NEW line either: `toTherapyRxWriteDto`
              // forwards `id`, and a made-up one makes the server treat a new
              // line as an existing one. Same rule as `toQuickRxWriteLine`.
              const therapyObj = {
                ...(therapyId ? { id: therapyId } : {}),
                amount: therapyNumber,
                therapy: therapy,
                rawText: typeof therapy === "string" ? therapy : therapy?.abbreviation ?? null,
                frequency: frequency,
              };
              // console.log("Therapyiiii", therapyObj);
              therapyRxs.push(therapyObj);
            }
          }
        }
        // console.log("JKKK", therapyRxs);
        // Update existing rx if found, otherwise create a new one
        if (existingRxIndex !== -1) {
          // console.log("ABN", therapyRxs);
          return {
            ...(patientValues?.rxs ? [existingRxIndex] : rx),
            isHomeVisit: rx.isHomeVisit,
            therapyRxs: therapyRxs,
          };
        } else {
          // console.log("RXFGG", rx);
          return {
            rxNumber: rx.rxNumber,
            id: rx.id,
            isHomeVisit: rx.isHomeVisit,
            creationDate: rx.creationDate,
            // date: rx.date,
            therapyRxs: therapyRxs,
          };
        }
      });

      // console.log("UPDFT", updatedRxs, rxtableData);
      const maxTherapies = Math.max(
        ...updatedRxs.map((rx: any) => (rx.therapyRxs ? rx.therapyRxs.length : 0))
      );

      // Calculate the number of new column sets to add
      const newColumnSetsCount = Math.max(0, maxTherapies - columnSets.length - 1);

      // Add new column sets if needed
      const newColumnSets = Array.from({ length: newColumnSetsCount }, (_, index) =>
        generateColumnSet(columnSets.length + index + 1)
      );
      setColumnSets((prevColumnSets) => [...prevColumnSets, ...newColumnSets]);
      // Check if any field other than 'id' has a value
      const haveRxs = (objects: any) => {
        for (const obj of objects) {
          let allValuesAreEmpty = true;

          for (const key in obj) {
            if (
              key !== "id" &&
              obj[key] !== undefined &&
              (!Array.isArray(obj[key]) || obj[key].length !== 0)
            ) {
              allValuesAreEmpty = false;
              break; // Exit the inner loop as soon as a non-empty value is found.
            }
          }

          if (allValuesAreEmpty) {
            return false; // Return false if all values are empty except 'id'.
          }
        }

        return true; // Return true if any object has at least one non-empty value.
      };

      handleData((prevValues: any) => ({
        ...prevValues,
        rxs: haveRxs(updatedRxs) ? updatedRxs : [],
      }));
    };
    const handleCloseAddEditDialog = (data: any) => {
      // Handle doctor data, LANR, and BSNR passed back from DoctorDialog
      // console.log("Received doctor data:", data);
      setAddEditDialogOpen(false);

      // Here you can perform further actions with the received data
      if (data && "number" in data) {
        const { number, clinicNumber, contactInfo, id } = data;

        // Update states or perform other operations based on the received data
        setSelectedLANR(number);
        setSelectedBSNR(clinicNumber);
        setSelectedDoctor(contactInfo?.lastName);
        setFormValues((prevFormValues: any) => ({
          ...prevFormValues,
          doctorNumber: number,
          practiceNumber: clinicNumber,
        }));

        // For example, you can update doctor form values if needed
        // setDoctorFormValues(doctorData);
      }
    };

    // const fetchDoctorOptions = async () => {
    //   try {
    //     const response = await getAllDoctors();
    //     console.log("Resppnse", response);
    //     setDoctorOptions(response);
    //   } catch (error) {
    //     console.error("Error fetching doctor options:", error);
    //   }
    // };
    const handleUnsavedChanges = (status: boolean) => {
      setUnsavedChanges(status);
    };
    const handleCloseRxDialog = () => {
      // console.log("shjsakjsajj", unsavedChanges);
      if (unsavedChanges) {
        // If there are unsaved changes, set a state to open the warning dialog
        setShowunsavedChangesWarning(true);
      } else {
        closeRxDialogAndReset();
      }
    };

    const handleUnsavedChangesWarning = () => {
      handleSubmit();
    };

    const handleCloseUnsavedChangesWarning = () => {
      closeRxDialogAndReset();
      // If user cancels and chooses not to continue, close the warning dialog
      setShowunsavedChangesWarning(false);
    };

    // const handleDoctorChange = (selectedValue) => {
    //   setSelectedDoctor(selectedValue);
    //   fetchData(selectedValue);
    // };
    const handleDeleteTherapy = (therapyId: string) => {
      // Filter out the therapy that matches the given ID
      const updatedTherapies = formValues.therapyRxs.filter(
        (therapy: any) => therapy.id !== therapyId
      );
      settherapyTableData(updatedTherapies);

      // Update formData state with new therapy list
      setFormValues({
        ...formValues,
        therapyRxs: updatedTherapies,
      });
    };

    const treatmentColumns: any[] = [
      // { field: "therapy", headerName: "Heilmittel", editable: true },
      {
        field: "Actions",
        headerName: "Actions",
        sortable: false,
        renderCell: (params: any) => (
          <IconButton size="small" onClick={() => handleDeleteTherapy(params.row.id)}>
            <Delete fontSize="small" />
          </IconButton>
        ),
      },
      { field: "amount", headerName: "Menge", editable: true },

      { field: "frequency", headerName: "Frequency", editable: true },
    ];
    const rxType = safeMasterData
      .filter((obj: any) => "rxType" in obj) // Filter objects that have the insuranceStatus property
      .map((obj: any) => obj.rxType);
    const diagnoseGroups = safeMasterData
      .filter((obj: any) => "diagnosisGroups" in obj)
      .map((obj: any) => obj.diagnosisGroups);
    const insurer = safeMasterData
      .filter((obj: any) => "insurer" in obj)
      .map((obj: any) => obj.insurer);

    const account = safeMasterData
      .filter((obj: any) => "account" in obj)
      .map((obj: any) => obj.account);
    // const doctors = masterData
    // .filter((obj: any) => "doctor" in obj)
    // .map((obj: any) => obj.doctor);
    const selectedInsurer = insurer[0]?.find(
      (insurer: any) =>
        insurer.id === patientValues?.payer || insurer.id === patientValues?.payer?.id
    );

    // const rxStatusOptions = Object.values(RxTherapyDtoStatusEnum).map(
    //   (value) => ({
    //     label: value,
    //     value: value,
    //   })
    // );
    const initialFormValues = {
      // receiptId
      //  PatientId
      rxtype: selectedRow?.rxtype || "",
      firstName: patientValues.firstName,
      lastName: patientValues.lastName,
      dob: patientValues.dob,
      accountId: "",
      employee: "",
      chipcard: selectedInsurer?.ik ?? "",
      tarifGroupId: patientValues?.tarifGroupId,
      // symptomCode: "",
      a: false,
      b: false,
      c: false,
      d: false,
      symptoms: "",
      Receiptpayer: patientValues?.payer,
      insuranceStatus: patientValues.status,
      insureeNumber: patientValues.insuranceNo,
      signatureStatus: "",
      isPerpetual: false,
      unvirtualize: false,
      isCopaymentExempted: false,
      isAccident: false,
      isBVG: false,
      status: "",
      hasIndividualSymptoms: false,
      hygiene: false,
      isAutoAddReport: false,
      urgent: false,
      // homeVisit: false,
      therapyReport: false,
      // isHomeVisitFree: false,
      date: patientValues.date,
      icdCodeEntries: [{ userText: "" }, { userText: "" }],
      practiceNumber: null,
      // number:"",
      doctorNumber: null,
      doctorId: "",
      clinicId: "",
      additionalNotes: "",
      diagnosegroup: null,
      diagnosisText: "",
      isPerpetualApproved: false,
      therapyRxs: [],
      creationDate: "",
      isHomeVisit: selectedRow?.isHomeVisit ?? null,
      problematic: false,
      changeRequested: false,
      clinic: {} as any,
    };

    // Fetch the insurer property from the selected insurer object, or use an empty string if not found
    const insurerName = selectedInsurer?.name ?? "";
    // console.log("Insurer", initialFormValues.icdCodeEntries, toJS(user));
    const [formValues, setFormValues] = useState(initialFormValues);
    const [icdCodeEntries, setIcdCodeEntries] = useState(initialFormValues.icdCodeEntries);
    const [unsavedChangesWarning, setShowunsavedChangesWarning] = useState(false);
    const [unsavedChanges, setUnsavedChanges] = useState(false); // Flag to track unsaved changes
    const rxvalidate = (fieldValues = formValues) => {
 
      let temp: any = { ...rxerrors }
      // if ("rxtype" in fieldValues)
      //   temp.rxtype = fieldValues.rxtype ? "" : "This field is required.";
      // Validate chipcard (if chipcard exists in fieldValues)
      if ("chipcard" in fieldValues) {
        const chipCardValue = fieldValues.chipcard;
        if (chipCardValue && !insurer[0]?.some((option: any) => option.ik === chipCardValue)) {
          temp.chipcard = "Ungültige Chipkartennummer";
        } else {
          temp.chipcard = ""; // Clear error if valid
        }
      }
      if ("accountId" in fieldValues)
        temp.accountId = fieldValues.accountId ? "" : "This field is required.";
      // if ("chipcard" in fieldValues)
      //   temp.chipcard = fieldValues.chipcard ? "" : "Pflichtfeld";
      // if ("Receiptpayer" in fieldValues)
      //   temp.Receiptpayer = fieldValues.Receiptpayer ? "" : "Pflichtfeld";
      if ("tarifGroupId" in fieldValues)
        temp.tarifGroupId = fieldValues.tarifGroupId  ? "" : "Pflichtfeld";
      // if ("practiceNumber" in fieldValues)
      //   temp.practiceNumber = fieldValues.practiceNumber
      //     ? ""
      //     : "This field is required.";
      // if ("doctorNumber" in fieldValues)
      //   temp.doctorNumber = fieldValues.doctorNumber
      //     ? ""
      //     : "This field is required.";
      // if ("doctorId" in fieldValues)
      //   temp.doctorId = fieldValues.doctorId ? "" : "This field is required.";

      // if ('email' in fieldValues)
      //     temp.email = (/$^|.+@.+..+/).test(fieldValues.email) ? "" : "Email is not valid."

      rxsetErrors({
        ...temp,
      });

      // Check if all values in the temp object are empty strings (valid)
      const isValid = Object.values(temp).every((x) => x === "");

      return isValid;

      // if (fieldValues == formValues)
      //   return Object.values(temp).every((x) => x == "");
    };
    const { rxerrors, rxsetErrors } = rxuseForm(initialFormValues, true, rxvalidate);

    // Initialize with two input boxes
    useEffect(() => {
      const fetchData = async () => {
        if (isEditing && selectedRow.rxNumber) {
          try {
            let rxs: [] = [];
            let updatedFormValues = { ...formValues };
            if (selectedRow.rxNumber) {
              const selectedRxNumber = selectedRow.rxNumber; // Assuming the property name is `number` for rxNumber in the selected row
              const filteredRxs = patientValues.rxs?.filter(
                (rx: any) => rx.rxNumber === selectedRxNumber
              );

              const formattedValues = { ...patientValues, rxs: filteredRxs };

              // console.log(
                // "56878",
                // patientValues,
                // formattedValues.rxs,
                // selectedRxNumber,
                // filteredRxs
              // );
              rxs = formattedValues.rxs
                ? formattedValues.rxs.flatMap((rx: any) => {
                    const therapyRxs = rx.therapyRxs || [];
                    // console.log("THERRTZZ", therapyRxs);
                    return therapyRxs?.map((therapy: any) => ({
                      id: therapy.id,
                      date: rx.date,
                      rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
                      therapy: therapyRxEditValue(therapy),
                      amount: therapy.amount,
                      frequency: therapy.frequency?.text || therapy.frequency,
                      unitsPerDay: therapy.unitsPerDay,
                      isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
                      rxSeries: therapy.rxSeries,
                    }));
                  })
                : [];
              formattedValues.rxs = formattedValues.rxs
                ? formattedValues.rxs.map((rx: any) => {
                    let icdCodeEntries;

                    if (rx.icdCodeEntries && rx.icdCodeEntries.length > 0) {
                      if (rx.icdCodeEntries.length === 1) {
                        icdCodeEntries = [...rx.icdCodeEntries, { userText: "" }];
                      } else {
                        icdCodeEntries = rx.icdCodeEntries;
                      }
                    } else {
                      icdCodeEntries = [{ userText: "" }, { userText: "" }];
                    }
                    return {
                      ...rx,
                      firstName: formattedValues.firstName,
                      lastName: formattedValues.lastName,
                      dob: moment(formattedValues.dob).format("YYYY-MM-DD"),
                      insuranceStatus: rx.insuranceStatus || formattedValues.status,
                      insureeNumber: rx.insureeNumber || formattedValues.insuranceNo,
                      Receiptpayer:
                        insurer[0].find((option: any) => option.id === rx.Receiptpayer)?.name ||
                        rx.payer?.name,
                      chipcard: rx.payer?.ik,
                      diagnosegroup:
                        diagnoseGroups[0].find((option: any) => option.id === rx.diagnosegroup)
                          ?.code || rx.diagnosisGroup?.code,
                      rxtype:
                        rxType[0].find((option: any) => option.id === rx.rxtype)?.text ||
                        rx.rxtype?.text,
                      accountId:
                        account[0].find((option: any) => option.id === rx.accountId)?.name ||
                        rx.account?.name,
                      icdCodeEntries: icdCodeEntries,
                      // Map new API field names to form's internal keys
                      doctorNumber: rx.LANR || "",
                      practiceNumber: rx.BSNR || "",
                      doctorId: rx.doctorId || rx.doctorNumber || "",
                      clinicId: rx.clinicId || rx.practiceNumber || "",
                    };
                  })
                : [];
              // console.log("Formateed", formattedValues.rxs);
              updatedFormValues = {
                ...formValues,
                ...formattedValues.rxs[0], // Assuming only one item is filtered
              };
              // console.log("GZTUUU", formValues, updatedFormValues);

              // handleData({...patientValues,rxs:filteredRxs})
            }
            // else {
            //   console.log("ARB", formValues, selectedRow);
            //   const formattedValues = { ...patientValues, rxs: [selectedRow] };

            //   rxs = formattedValues.rxs
            //     ? formattedValues.rxs.map((rx: any) => ({
            //         id: rx.id,
            //         date: rx.date,
            //         number: rx.number,
            //         therapy: rx.therapy,
            //         frequency: rx.frequency,
            //         therapyId: rx.therapyId,
            //       }))
            //     : [];
            // }
            setFormValues(updatedFormValues);
            // console.log("RDFF", rxs, formValues);
            settherapyTableData(rxs);
          } catch (error) {
            // console.log("error", error);
          }
          // };

          // fetchData();
          // dummyApiFetch().then((data) => {
          //   setValues(data);
          // });
        }
        // Make API request to fetch patient data based on patient ID or any other identifier
        else {
          const rx = patientForm
            ? patientValues.rxs?.filter((rx: any) => rx.id === selectedRow.id)[0]
            : selectedRow;
          // console.log("RXZZZ", selectedRow);

          const therapyRxs = rx?.therapyRxs?.map((therapy: any) => ({
            id: therapy.id || uuidv4(),
            date: rx.date,
            rawText: therapy.rawText ?? therapy.prescribedTherapyId ?? null,
            therapy: therapyRxEditValue(therapy),
            amount: therapy.amount,
            frequency: therapy.frequency.text || null,
            unitsPerDay: therapy.unitsPerDay,
            isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
            rxSeries: therapy.rxSeries,
          }));

          settherapyTableData(therapyRxs || []);
          const updatedRx = {
            ...formValues,
            ...rx,
            accountId:
              account[0].find((option: any) => option.id === rx?.accountId)?.name ||
              rx?.accountId ||
              accounts?.[0]?.id,
            diagnosegroup:
              diagnoseGroups[0].find((option: any) => option.id === rx?.diagnosegroup)?.code ||
              rx?.diagnosisGroup?.code,
            rxtype:
              rxType[0].find((option: any) => option.id === rx?.rxtype)?.text || rx?.rxtype?.text,
            Receiptpayer:
              insurer[0].find((option: any) => option.id === rx?.Receiptpayer)?.name || insurerName,
              tarifGroupId:
              rx?.tarifGroupId || patientValues?.tarifGroupId,
            // icdCodeEntries:filteredRxs[0].icdCodeEntries,
            // Map new API field names to form's internal keys
            doctorNumber: rx?.LANR || "",
            practiceNumber: rx?.BSNR || "",
            doctorId: rx?.doctorId || rx?.doctorNumber || "",
            clinicId: rx?.clinicId || rx?.practiceNumber || "",
          };

          // // // const updatedFormValues = { ...formValues, rxs: updatedRxs };
          setFormValues(updatedRx);
        }
      };
      fetchData();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditing, patientValues.rxs, selectedRow]);

    // useEffect(() => {
    //   fetchDoctorOptions();
    // }, []);
    // Call the function whenever isAddEditDialogOpen becomes true
    // useEffect(() => {
    //   if (isAddEditDialogOpen) {
    //     fetchDoctorOptions();
    //   }
    // }, [isAddEditDialogOpen]);
    // useEffect to log the updated formValues

    useEffect(() => {
      setIcdCodeEntries(formValues.icdCodeEntries);
      // console.log("Updated icdCodeEntries:", formValues.icdCodeEntries);
    }, [formValues]);

    // console.log("Fteched", formValues);
    const [isHausbesuchSelected, setHausbesuchSelected] = useState<boolean | null>(
      formValues.isHomeVisit
    );
    const handleCheckboxChange = (event: any) => {
      const selectedValue = event.target.value; // "yes" or "no"

      if (selectedValue === "yes") {
        setHausbesuchSelected(true);
        // Set isHomeVisit to true if "yes" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: true,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else if (selectedValue === "no") {
        setHausbesuchSelected(false);
        // Set isHomeVisit to false if "no" is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: false,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      } else {
        setHausbesuchSelected(null); // Set null if neither is selected
        // Set isHomeVisit to null if neither checkbox is selected
        handleInputChange({
          target: {
            name: "isHomeVisit",
            value: null,
          } as unknown as EventTarget & HTMLInputElement, // Cast to EventTarget & HTMLInputElement
        } as React.ChangeEvent<HTMLInputElement>);
      }
    };

    const handleInputChange = (
      event: React.ChangeEvent<HTMLInputElement>,
      index?: any,
      icdEntryId?: string
    ) => {
      // console.log("LUUZZ", event);
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { name, value, checked, type, id } = event.target;
      setUnsavedChanges(true);

      const inputValue = type === "checkbox" ? checked : value;
      if (name === "practiceNumber") {
        if (value.length > 9) return;
      }

      if (name === "doctorNumber") {
        if (value.length > 9) return;
        // Only update the field, do not clear doctor info here!
        setFormValues((prevValues: any) => ({
          ...prevValues,
          doctorNumber: value,
        }));
        return;
      }
      setFormChanged(true);

      // The Rezept-typ DECIDES the tarif group — a Privat/Selbstzahler Rx is
      // billed against the Privat tarif group whatever the patient's own group
      // is. `tarifGroupId` is seeded from the patient when the dialog opens
      // (the common case, where they agree), so without this the seeded value
      // survived the type change and a private Rx was created as GKV.
      //
      // Both Rezept-typ selects route through here (the inline one and the
      // warning dialog's), so this is the single place it can be enforced.
      if (name === "rxtype") {
        // Only the tarif group here — `rxtype` itself is written by the generic
        // setter below, and a later branch clears the diagnosis group. Setting
        // state and returning early would skip both. Functional updates compose
        // in order, so this survives them.
        const selectedRxTypeId = String(id ? id : inputValue);
        const { nextTarifGroupId, requiresChoice } = resolveTarifGroupForRxType(
          safeMasterData,
          selectedRxTypeId,
          formValues?.tarifGroupId,
          accountTherapyType
        );
        setFormValues((prevValues: any) => ({
          ...prevValues,
          tarifGroupId: nextTarifGroupId,
        }));
        if (requiresChoice) {
          notificationStore.showMessage(
            "Bitte wählen Sie eine Tarifgruppe für den gewählten Rezept-Typ.",
            "warning"
          );
        }
      }
      // console.log("input", inputValue, checked);
      // console.log("Event:", event.target.name, event.target.value, index);
      // Check if the input is for icdCodeEntries
      if (name.startsWith("icdCodeEntries")) {
        const inputElement = document.querySelector(`[name="${name}"]`) as
          | HTMLInputElement
          | HTMLTextAreaElement;
        const cursorPosition = inputElement?.selectionStart || 0;
        let updatedValue = value;
        let newCursorPosition = cursorPosition; // Initialize new cursor position

        // Check if the length is at least 4 and if a period needs to be inserted
        if (value.length >= 4) {
          // Check if the period already exists at the correct position
          if (!value.includes(".")) {
            // Insert a period after the third character if it's not already there
            updatedValue = value.slice(0, 3) + "." + value.slice(3);

            // Adjust cursor position if a period was inserted before the original cursor position
            if (cursorPosition > 3) {
              newCursorPosition = cursorPosition + 1; // Move cursor one position forward
            }
          }
        }

        // Update the form values with the correctly formatted value
        setFormValues((prevValues: any) => ({
          ...prevValues,
          icdCodeEntries: prevValues.icdCodeEntries.map((icdEntry: any, i: number) => {
            return i === index
              ? { id: icdEntryId || undefined, userText: updatedValue }
              : { id: icdEntry?.id, userText: icdEntry?.userText || "" };
          }),
        }));

        // Restore cursor position after the update
        setTimeout(() => {
          if (inputElement) {
            inputElement.selectionStart = inputElement.selectionEnd = newCursorPosition;
          }
        }, 0);
      }

      // if (name.startsWith("icdCodeEntries")) {
      //   setFormValues((prevValues: any) => ({
      //     ...prevValues,
      //     icdCodeEntries: prevValues.icdCodeEntries.map((icdEntry: any, i: number) => {
      //       return i === index ? { id:icdEntryId || undefined, userText: inputValue } : {id:icdEntry?.id,userText:icdEntry?.userText|| ""};
      //     }),
      //   }));
      // }
      // Leitsymptomatik: the a/b/c/d codes and the patientenindividuelle flag are
      // independent — a Verordnung can require both, so neither clears the other.
      // Update form fields based on their names
      setFormValues((prevValues: any) => ({
        ...prevValues,
        [name]: id ? id : inputValue,
      }));

      // setFormValues((prevValues: any) => ({
      //   ...prevValues,
      //   rxs: prevValues.rxs.map((rx: any) => ({
      //     ...rx,
      //     [name]: id ? id : inputValue,
      //   })),
      // }));
      // if (name === "doctorNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions?.find(
      //     (doctor: any) => doctor.number === Number(value)
      //   );
      //   setFetchedData(selectedDoctor);
      //   console.log("UZZHHHH", selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       practiceNumber: selectedDoctor.clinicNumber,
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedBSNR(selectedDoctor.clinicNumber);
      //   }
      // }

      // if (name === 'rxtype') {
      //   filterDiagnoseGroups(value);
      // }

      if (name === "rxtype") {
        setFormValues((prevValues) => ({
          ...prevValues,
          diagnosegroup: null, // Clear diagnosegroup when rxtype changes
        }));
        filterDiagnoseGroups(value);
      }
      // if (name === "practiceNumber") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.clinicNumber === Number(value)
      //   );
      //   setFetchedData(selectedDoctor);
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       doctorId: selectedDoctor.id,
      //       doctorNumber: selectedDoctor.number,
      //     }));
      //     setSelectedDoctor(selectedDoctor.contactInfo.lastName);
      //     setSelectedLANR(selectedDoctor.number);
      //   }
      // }
      if (name === "Receiptpayer") {
        // Autopopulate doctor and bsnr based on LANR selection
        const selectedPayer: any = insurer[0].find(
          (option: any) => option.id === id || option.ik === value
        );
        // console.log("UZZHHHH", selectedPayer);
        if (selectedPayer) {
          setFormValues((prevFormValues: any) => ({
            ...prevFormValues,
            chipcard: selectedPayer?.ik,
            // tarifGroupId: selectedPayer?.tarifGroup.id,
          }));
          setSelectedChipCard(selectedPayer.ik);
          // console.log("selectedPayer", selectedPayer.name);
        }
      }

      // if (name === "chipcard") {
      //   const selectedPayer: any = insurer[0].find(
      //     (option: any) => option.ik === value
      //   );
      //   console.log("UZZHHHH", selectedPayer);
      //   if (selectedPayer) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       Receiptpayer: selectedPayer.id,
      //       tarifGroupId: selectedPayer?.tarifGroup?.id,
      //     }));

      //     setSelectedPayer(selectedPayer.name);
      //     console.log("selectedPayer", selectedPayer.name);
      //   }
      // }
      // console.log("GTII", formValues);

      // else if (name === "doctor") {
      //   // Autopopulate doctor and bsnr based on LANR selection
      //   const selectedDoctor: any = doctorOptions.find(
      //     (doctor: any) => doctor.contactInfo.firstNames===value

      //   );
      //   if (selectedDoctor) {
      //     setFormValues((prevFormValues: any) => ({
      //       ...prevFormValues,
      //       lanr: selectedDoctor.number,
      //       bsnr: selectedDoctor.clinicNumber,
      //     }));
      //     setSelectedLANR(selectedDoctor.number);
      //   }
      //   console.log('DOCTOR',selectedDoctor,formValues,value,doctorOptions)
      // }
    };

    const handleChipCardDataEntry = (event: React.KeyboardEvent | React.FocusEvent) => {
      rxvalidate();
      const chipCardValue = (event.currentTarget as HTMLInputElement).value;
      if (
        (event as React.KeyboardEvent).key === "Enter" ||
        event.type === "blur" ||
        event.type === "mouseleave"
      ) {
        // Check if the chipcard number is valid
        const selectedPayer = insurer[0]?.find((option: any) => option.ik === chipCardValue);
        if (selectedPayer) {
          // If valid, autofill payer info
          setFormValues((prevFormValues: any) => ({
            ...prevFormValues,
            Receiptpayer: selectedPayer?.id,
            // tarifGroupId: selectedPayer?.tarifGroup?.id,
          }));
          setSelectedPayer(selectedPayer.name);
          notificationStore.showMessage(
            `${selectedPayer?.id} ist ein IK für ${selectedPayer?.name}`,
            "success"
          );
        } else if (chipCardValue) {
          // Show error if chipcard is invalid
          notificationStore.showMessage(
            "Bitte geben Sie eine gültige Chipkartennummer ein.",
            "warning"
          );
          // Pass all form values with updated chipcard value for validation
        }
      }
    };
    useEffect(() => {
      rxvalidate();
    }, [formValues]);
    const handleAddInput = () => {
      setIcdCodeEntries([...icdCodeEntries, { userText: "" }]);

      // Update the formValues state as well to reflect the new entry
      setFormValues((prevValues) => ({
        ...prevValues,
        icdCodeEntries: [...prevValues.icdCodeEntries, { userText: "" }],
      }));
    };
      const handleICDCodeEntrySubmit = useCallback(
          async (icdEntry: any, index: number) => {
    
            try {
              setFormValues((prevValues: any) => {
                const updatedICDCodeEntries = prevValues.icdCodeEntries.map((entry: any, i: number) =>
                  i === index ? { id: icdEntry.id || "", userText: icdEntry.userText } : entry
                );
    
                // Avoid duplicating diagnosis text
                const existingICDTexts = prevValues.icdCodeEntries.map((e: any) => e.userText);
                const newDiagnosisText = existingICDTexts.includes(icdObject.text)
                  ? prevValues.diagnosisText
                  : prevValues.diagnosisText
                  ? `${prevValues.diagnosisText} ${icdObject.text}`
                  : icdObject.text;
    
                return {
                  ...prevValues,
                  icdCodeEntries: updatedICDCodeEntries,
                  diagnosisText: newDiagnosisText.trim(),
                };
              });
            } catch (error) {
              console.error("Error updating ICD entry:", error);
            }
          },
          [icdObject]
        );
    
        useEffect(() => {
          if (icdObject) {
            // Use latest index and currentICD
            const index = icdCodeEntries.findIndex((e) => e.userText === currentICD);
            handleICDCodeEntrySubmit(icdCodeEntries[index], index);
          }
        }, [icdObject]);

    // const handleICDCodeEntrySubmit = async (icdCode: any, index: number) => {
    //   try {
    //     // TODO: Replace with useIcdCodes hook or move this logic to a different approach
    //     // const icdObject: any = await getICD(icdCode.userText);
    //     const icdObject: any = null; // Temporary placeholder
    //     console.log("OOPP", icdObject);
    //     if (icdObject) {
    //       // If the API call is successful and returns an icdObject, update the icdCodeEntries state with the normCode
    //       setFormValues((prevValues: any) => {
    //         const updatedICDCodeEntries = prevValues.icdCodeEntries.map(
    //           (icdEntry: any, i: number) => {
    //             return i === index
    //               ? { id: icdCode?.id || "", userText: icdCode.userText }
    //               : icdEntry;
    //           }
    //         );

    //         const concatenatedDiagnosisText = prevValues.diagnosisText
    //           ? `${prevValues.diagnosisText} ${icdObject.text}` // Append the new icdObject.text to the existing diagnosisText
    //           : icdObject.text;
    //         return {
    //           ...prevValues,
    //           icdCodeEntries: updatedICDCodeEntries,
    //           diagnosisText: concatenatedDiagnosisText.trim(), // Set diagnosisText to the concatenated value
    //         };
    //       });
    //     }
    //   } catch (error) {
    //     console.error("Error fetching ICD object:", error);
    //   }
    // };

    // console.log("UZRRFCFASG", icdCodeEntries);

    useEffect(() => {
      if (formValues.diagnosegroup) {
        const diagnoseGroupIsId = diagnoseGroups[0].some(
          (group: any) => group.id === formValues.diagnosegroup
        );
        // Find the matching diagnose group based on the selected code
        const selectedDiagnoseGroup = diagnoseGroupIsId
          ? diagnoseGroups[0].find((group: any) => group.id === formValues.diagnosegroup)
          : diagnoseGroups[0].find((group: any) => group.code === formValues.diagnosegroup);
        // console.log("formVa", formValues.diagnosegroup, selectedDiagnoseGroup, diagnoseGroups);

        if (selectedDiagnoseGroup) {
          // Generate symptoms based on selected checkboxes
          let selectedSymptoms = "";
          if (formValues.a) selectedSymptoms += selectedDiagnoseGroup.a + " ";
          if (formValues.b) selectedSymptoms += selectedDiagnoseGroup.b + " ";
          if (formValues.c) selectedSymptoms += selectedDiagnoseGroup.c + " ";
          if (formValues.d) selectedSymptoms += selectedDiagnoseGroup.d + " ";
          // console.log("SELECTE", selectedSymptoms, selectedDiagnoseGroup);
          setSelectedDiagnoseGroup(selectedDiagnoseGroup);
          setFormValues((prevValues) => ({
            ...prevValues,
            a: selectedDiagnoseGroup.a ? prevValues.a : false,
            b: selectedDiagnoseGroup.b ? prevValues.b : false,
            c: selectedDiagnoseGroup.c ? prevValues.c : false,
            d: selectedDiagnoseGroup.d ? prevValues.d : false,
            ...(prevValues.hasIndividualSymptoms ? {} : { symptoms: selectedSymptoms.trim() }),
          }));
        }
      }
    }, [formValues.diagnosegroup, formValues.a, formValues.b, formValues.c, formValues.d]);

    const warningDoctorSignatureConditions = () => {
      return (
        (formValues.status === "vorhanden" || formValues.status === "beim Therapeut") &&
        formValues.signatureStatus === ""
      );
    };

    const handleSubmit = async (event?: any) => {
      if (event) {
        setLoading(false);
        event.preventDefault(); // Prevent default form submission behavior
        // console.log("Event", event);
      }
      try {
        setLoading(true);
        if (warningDoctorSignatureConditions() && event) {
          // Show a warning/alert here

          setShowWarning(true);
        } else {
          // console.log("HJJUU", formValues, therapytableData.length, formValues.therapyRxs.length);
          //       const newColumnSet = [...treatmentColumns];
          //       const newRowAdded = Math.abs(formValues.therapies.length - therapytableData.length);
          // console.log('Newro',newRowAdded)
          //       for (let i = 0; i < newRowAdded; i++) {
          //         handleAddColumnSet(newColumnSet);
          //       }

          if (rxvalidate()) {
          // The doctor must actually be registered at the practice the Rx names:
          // the stamp takes its telephone number from the PRACTICE, so a
          // mismatched pair prints a stranger's number on a document that leaves
          // the building. Asked here rather than on a field, because the Arzt-Nr
          // check only fires when that field loses focus - correcting the BSNR
          // afterwards, or re-saving an Rx loaded from the database, slips past it.
          if (!(await confirmDoctorClinicMismatch(currentDoctor, currentClinic))) {
            return;
          }
            const updatedRxValues: any = {
              ...formValues,
              id: selectedRow?.id || "",
              rxNumber:
                patientValues?.rxs?.find((rx: any) => rx.id === selectedRow.id)?.rxNumber || "",
              // date:
              //   patientValues.rxs.find((rx: any) => rx.id === selectedRow.id)
              //     ?.date || "",
              accountId:
                account[0].find((option: any) => option.name === formValues.accountId)?.id ||
                formValues.accountId,
              rxtype:
                rxType[0].find((option: any) => option.text === formValues.rxtype)?.id ||
                formValues.rxtype,
              diagnosegroup:
                diagnoseGroups[0].find((option: any) => option.code === formValues.diagnosegroup)
                  ?.id || formValues.diagnosegroup,
              Receiptpayer:
                insurer[0].find((option: any) => option.id === formValues.chipcard)?.id ||
                formValues.Receiptpayer,
              therapyRxs: (formValues.therapyRxs || [])
                // MD-232: a row is real when it NAMES A TERM. Gating on
                // `therapy.id` dropped every freshly entered row, and threw a
                // TypeError on an API line, which has no `therapy` at all.
                .filter(rowNamesTerm)
                .map((therapy: any) => {
                  if (
                    !(therapy.frequency && therapy.frequency.id) ||
                    !rowNamesTerm(therapy) ||
                    !therapy.amount
                  ) {
                    throw new Error(
                      "Bitte fügen Sie die Behandlung hinzu, um das Rezept zu speichern/bearbeiten (Therapie, Menge, Häufigkeit sind Pflichtfelder) und deaktivieren Sie auch die Zelle nach der Bearbeitung!"
                    );
                  }
                  const validTherapy = validateTherapy(
                    rowTermText(therapy),
                    safeMasterData,
                    termOptions
                  );
                  const validFrequency = validateFrequency(therapy.frequency.id, safeMasterData);
                  if (!validTherapy || !validFrequency) {
                    throw new Error("Bitte geben Sie eine gültige Therapie und Häufigkeit ein.");
                  }
                  return {
                    ...therapy,
                    id: therapy.therapyId || therapy.id,
                    frequency: therapy.frequency,
                    unitsPerDay: therapy.unitsPerDay,
                    isDoubled: (therapy.unitsPerDay ?? (therapy.isDoubled ? 2 : 1)) > 1,
                    rxSeries: therapy.rxSeries,
                    isSupplementary: therapy?.isSupplementary,
                  };
                }),
            };

            if (currentDoctor) {
              updatedRxValues.doctorId = (currentDoctor as any).id || formValues.doctorId;
              updatedRxValues.LANR = (currentDoctor as any).LANR || formValues.doctorNumber || "";
            } else {
              updatedRxValues.doctor = null;
              updatedRxValues.doctorId = null;
              updatedRxValues.doctorNumber = "";
              updatedRxValues.LANR = "";
            }
            if (currentClinic) {
              updatedRxValues.clinicId = currentClinic.id || formValues.clinicId;
              updatedRxValues.BSNR = (currentClinic as any).BSNR || formValues.practiceNumber || "";
            } else {
              updatedRxValues.clinic = null;
              updatedRxValues.clinicId = null;
              updatedRxValues.practiceNumber = "";
              updatedRxValues.BSNR = "";
            }

            const updatedFormData = {
              ...patientValues,
              rxs: patientValues?.rxs?.map((rx: any) =>
                rx.id === selectedRow.id ? updatedRxValues : rx
              ),
            };
            setFormValues(updatedRxValues);
            if (!patientForm) {
              patientSaveRxs({ patientId: patientValues.id!, rxs: [updatedRxValues] });

              setUnsavedChanges(false);
              // const updatedPatientData = updatedFormData?.rxs?.forEach(
              //   (updatedRx: any) => {
              //     const correspondingRx = response.rxs?.find(
              //       (rx: any) => rx.id === updatedRx.id
              //     );
              //     if (correspondingRx) {
              //       updatedRx.icdCodeEntries = correspondingRx.icdCodeEntries;
              //     }
              //   }
              // );
              // if(!response.patient?.messages){
              //     notificationStore.showMessage("Das Rezept.","success");}
            } else {
              onTableDataChange(updatedFormData.rxs);
              if (rxTableDataChange) rxTableDataChange(updatedFormData.rxs);
              handleData(updatedFormData);
              notificationStore.showMessage(
                "Das Rezept ist gespeichert. Bitte senden Sie das Patientenformular ab, um es zu speichern.",
                "success"
              );
            }

            closeRxDialogAndReset();
            //   const updatedTherapies = formValues.therapies;

            // const updatedRx = {
            //   ...selectedRow,
            //   therapies: updatedTherapies,
            // };

            // const updatedRxs = patientValues.rxs.map((rx: any) =>
            //   rx.id === updatedRx.id ? updatedRx : rx
            // );

            // const updatedPatientValues = {
            //   ...patientValues,
            //   rxs: updatedRxs,
            // };

            // handleData(updatedPatientValues);
            // handleCloseDialog();
          } else {
            notificationStore.showMessage(
              "Bitte füllen Sie alle erforderlichen Felder aus",
              "warning"
            );
          }
        }
      } catch (error: any) {
        // console.log("Error adding rezept:", error);
        notificationStore.showMessage(error.message, "error");
      } finally {
        // Set loading back to false when the API call is complete
        setLoading(false);
      }
    };
    const handleContinueWarning = () => {
      setShowWarning(false); // Close the warning dialog
      handleSubmit(); // Call handleSubmit directly
    };

    // function to check the order of therapies
    const hasInvalidTherapyOrder = (data: any[]): boolean => {
      let encounteredNonHeatTreatment = false;

      for (let i = 0; i < data.length; i++) {
        const therapyAbbreviation = data[i].therapy.abbreviation;
        if (PASSIVE_ABBREVIATIONS_AT_ENTRY.includes(therapyAbbreviation)) {
          if (encounteredNonHeatTreatment) {
            // if we encounter a heat treatment after a non-heat treatment, return invalid
            return true;
          }
        } else {
          // mark that we've encountered a non-heat treatment
          encounteredNonHeatTreatment = true;
        }
      }
      return false;
    };

    const handletherapyTableDataChange = (data: RowData[]) => {
      // console.log("datatttzz", data);
      // // Create a new array to hold the updated data
      const updatedData: any[] = [];
      data.forEach((item: any, index: number) => {
        // Divide the amount by 2 for the original item
        const updatedAmount = item.amount;

        // Update the original item with the new amount
        const updatedItem = {
          ...item,
          therapy: {
            id: item.therapy,
            abbreviation: item.therapy,
            isSupplementary: item?.isSupplementary,
          },
          frequency: { id: item.frequency, text: item.frequency },
          amount: updatedAmount,
          unitsPerDay: item.unitsPerDay,
          isDoubled: (item.unitsPerDay ?? (item.isDoubled ? 2 : 1)) > 1,
          order: data.length > 1 ? index + 1 : null,
        };

        // Doubling is `unitsPerDay` on the one line (MD-232) — no split row.
        updatedData.push(updatedItem);
      });

      const isInvalidOrder = hasInvalidTherapyOrder(updatedData);
      if (isInvalidOrder) {
        // console.log("Invalid therapy order detected");
        notificationStore.showMessage(
          "Die Reihenfolge der Therapien ist ungültig. Bitte überprüfen Sie die Reihenfolge der Therapien und korrigieren Sie sie.",
          "error"
        );
        return;
      }

      // setFormValues((prevData: any) => ({
      //   ...prevData,
      //   therapyRxs: updatedData,
      // }));
      // Update the form values state and call setUnsaved(true) if the data has changed
      setFormValues((prevData: any) => {
        const newFormValues = {
          ...prevData,
          therapyRxs: updatedData,
        };
        // Compare new form values with previous ones
        if (
          prevData.therapyRxs &&
          JSON.stringify(prevData.therapyRxs) !== JSON.stringify(updatedData) &&
          prevData.therapyRxs.length > 0 &&
          updatedData.length > 0
        ) {
          setUnsavedChanges(true);
        }

        return newFormValues;
      });
      // console.log("jkkkkk", formValues);
    };

    // console.log("FORM", formValues.symptoms);
    let formattedDob: any; // Initialize formattedDob to an empty string

    if (formValues?.dob) {
      const parsedDate: any = new Date(formValues.dob);
      if (!isNaN(parsedDate)) {
        // Check if the parsed date is valid
        formattedDob = format(parsedDate, "dd.MM.yyyy");
      }
    }

    const [filteredDiagnoseGroups, setFilteredDiagnoseGroups] = useState([]);

    // Derive therapyType from the selected account (Physio vs. Ergo)
    const accountTherapyType = useMemo(() => {
      if (!formValues.accountId || !accounts) return "Physiotherapie";
      const selectedAccount = accounts.find(
        (a: any) => a.name === formValues.accountId || a.id === formValues.accountId
      );
      return selectedAccount?.therapyType || "Physiotherapie";
    }, [formValues.accountId, accounts]);

    // Valid tarif groups for the currently chosen Rezept-typ — all of them
    // until one is chosen, or when the type maps to none at all — narrowed to
    // the ones this practice's therapy type actually has line items for.
    const tarifGroupsForRxType = React.useMemo(
      () =>
        resolveTarifGroupForRxType(
          safeMasterData,
          formValues?.rxtype,
          formValues?.tarifGroupId,
          accountTherapyType
        ).options,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [formValues?.rxtype, formValues?.tarifGroupId, safeMasterData, accountTherapyType]
    );

    const filterDiagnoseGroups = (rxtype: any) => {
      const filtered = diagnoseGroups[0].filter(
        (option: any) =>
          option.RxType?.id === rxtype &&
          (!option.therapyType || option.therapyType === accountTherapyType)
      );
      setFilteredDiagnoseGroups(filtered);
    };

    useEffect(() => {
      filterDiagnoseGroups(formValues.rxtype);
    }, [formValues.rxtype, accountTherapyType]);

    const [showWarningDialog, setShowWarningDialog] = useState(false);
    useEffect(() => {
      if (openDialog && formValues && (formValues as any)?.id && !formValues?.rxtype) {
        setShowWarningDialog(true);
      }
    }, [openDialog, formValues?.rxtype]);

    const handleWarningDialogClose = () => {
      setShowWarningDialog(false);
    };

    const handleRxTypeSelection = (e: any) => {
      handleInputChange(e);
      setShowWarningDialog(false);
    };
    const [isSubmit, setIsSubmit] = useState(false);
    /**
     * MD-514: `formValues` is the NEW-Rx form's own state, and it is handed
     * straight back to that form as `newFormData` on the next open — where
     * `rxFormData = entryType && newFormData ? newFormData : rxData` makes it
     * the seed. Nothing ever reset it, so every prescription after the first
     * started from the previous one, inheriting its Mandant and tarif group
     * and compounding through the `{ ...formValues }` merges. A page reload
     * was the only way back to a clean form.
     *
     * Reset whenever the dialog closes — saved, cancelled or discarded alike.
     * `isSubmit` goes first and in the same batch, so the submit effect below
     * does not see the fresh values and fire again.
     */
    const closeRxDialogAndReset = () => {
      setIsSubmit(false);
      setFormValues(initialFormValues);
      handleCloseDialog();
    };

    const setFormDataChange = (rxFormData: any) => {
      // console.log("sakaksksa", unsavedChanges);
      // setUnsavedChanges(false);
      setFormValues(rxFormData);

      setIsSubmit(true);
    
    };

    useEffect(() => {
      if (formValues && isSubmit) {
        // Ensure formValues is not null or undefined
        // console.log("sjkaslkakllkdalkdaksdadsakdla", formValues);
        handleSubmit();
      }
    }, [formValues]);

    useEffect(() => {
      setCurrentDoctor(selectedRow?.doctor);
      setCurrentClinic(selectedRow?.clinic);
      if (selectedRow?.doctor || selectedRow?.clinic) {
        setFormValues((prev: any) => ({
          ...prev,
          doctorId: selectedRow?.doctor?.id || prev.doctorId,
          clinicId: selectedRow?.clinic?.id || prev.clinicId,
          doctorNumber: selectedRow?.doctor?.LANR || prev.doctorNumber,
          practiceNumber: selectedRow?.clinic?.BSNR || prev.practiceNumber,
        }));
      }
    }, [selectedRow?.doctor, selectedRow?.clinic]);

    useEffect(() => {
      if (creationResponse && creationResponse.doctorId && creationResponse.clinicId) {
        setCurrentDoctor({
          id: creationResponse.doctorId,
          contactInfo: creationResponse.contactInfo as any,
          clinics: creationResponse.clinics,
        });
        const matchedClinic = creationResponse.clinics.find((clinic: any) => clinic.id === creationResponse.clinicId);
        setCurrentClinic(matchedClinic);
        setFormValues((prev: any) => ({
          ...prev,
          doctorId: creationResponse.doctorId || "",
          clinicId: creationResponse.clinicId || "",
          doctorNumber: (creationResponse as any).LANR || prev.doctorNumber || "",
          practiceNumber: (matchedClinic as any)?.BSNR || prev.practiceNumber || "",
        }));
      }
    }, [creationResponse]);

    const handlePracticeNumberInteraction = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      if (isKeyboardEvent && isTriggerKey && value.length !== 0 && value.length !== 9) {
        e.preventDefault();
        notificationStore.showMessage("Mindestens 9 Zeichen erforderlich", "error");
        return;
      }

      if ((e.type === "blur" || isTriggerKey) && (value.length === 9 || value.length === 0)) {
        // setIsDoctorNumberDisabled(false);
        try {
          if (value.length === 9) {
            const clinicData = (await getClinicById(value)) as ClinicForModal;
            if (clinicData) {
              setDoesClinicExist(true);
              setCurrentClinic(clinicData);
              setFormValues((prev: any) => ({ ...prev, clinicId: clinicData.id }));
              setShowClinicData(true);
            } else {
              setDoesClinicExist(false);
              setCurrentClinicId(value);
              setCurrentDoctorId(currentDoctor?.id || "");
              setShowClinicData(false);
              setCurrentClinic(undefined);
              setIsClinicModalOpen(true);
            }
          } else if (value.length === 0) {
            setCurrentClinic(undefined);
          }
        } catch (error) {}
      }
    };

    const handleGetDoctorById = async (
      e: React.FocusEvent<HTMLInputElement> | React.KeyboardEvent<HTMLInputElement>
    ) => {
      const value = (e.target as HTMLInputElement).value;

      const isKeyboardEvent = e.type === "keydown";
      const isTriggerKey =
        (e as React.KeyboardEvent).key === "Enter" || (e as React.KeyboardEvent).key === "Tab";

      if (isKeyboardEvent && isTriggerKey && value.length !== 0 && value.length !== 9) {
        e.preventDefault();
        notificationStore.showMessage("LANR muss 9-stellig sein", "error");
        return;
      }

      if ((e.type === "blur" || isTriggerKey) && (value.length === 9 || value.length === 0)) {
        try {
          if (value.length === 9) {
            const doctorData: any = await getDoctorById(value);
            // console.log("doctor DATA -------> ", doctorData);
            if (doctorData) {
              setDoesDoctorExist(true);
              setCurrentDoctor(doctorData);
              setFormValues((prev: any) => ({ ...prev, doctorId: doctorData.id }));
              if (currentClinic && currentClinic.id) {
                const isDoctorInClinic = doctorData.clinics?.some(
                  (clinic: any) => clinic.id === currentClinic.id
                );
                if (isDoctorInClinic) {
                  notificationStore.showMessage(
                    "This doctor exists and is already associated with this clinic",
                    "success"
                  );
                } else {
                  const confirmed = await confirmDoctorClinicJoin(doctorData, currentClinic);
                  if (!confirmed) {
                    // User cancelled — clear the doctor selection (treat as a mistake).
                    setCurrentDoctor(undefined);
                    setDoesDoctorExist(false);
                    setSelectedLANR(null);
                    setFormValues((prev: any) => ({ ...prev, doctorId: "", doctorNumber: "" }));
                    return;
                  }
                  notificationStore.showMessage(
                    "This doctor exists already and will now get associated with this clinic",
                    "success"
                  );
                  handleAssociateDoctorToClinic(doctorData);
                }
              } else {
                notificationStore.showMessage(
                  "Bitte geben Sie zuerst eine gültige Betriebsstätten-Nr. (BSNR) ein.",
                  "warning"
                );
              }
            } else {
              setDoesDoctorExist(false);
              setIsClinicModalOpen(true);
              setCurrentDoctorId(value);
              setCurrentClinicId(currentClinic?.id || "");
            }
          } else if (value.length === 0) {
            setCurrentDoctor(undefined);
          }
        } catch (error) {}
      }
    };

    enum ReportMethod {
      Email = "Email",
      Fax = "Fax",
      Post = "Post",
    }

    const handleAssociateDoctorToClinic = async (doctorData: any) => {
      const createDoctorClinicDto = {
        id: doctorData?.id || "",
        contactInfo: {
          salutation: doctorData?.contactInfo?.salutation || "",
          firstNames: doctorData?.contactInfo?.firstNames || "",
          lastName: doctorData?.contactInfo?.lastName || "",
        },
        clinics: [
          {
            id: currentClinic?.id || "",
            contactInfo: {
              businessName: currentClinic?.contactInfo?.businessName || "",
              phone1: currentClinic?.contactInfo?.phone1 || "",
              fax: currentClinic?.contactInfo?.fax || "",
              addressLine1: currentClinic?.contactInfo?.addressLine1 || "",
              addressLine2: currentClinic?.contactInfo?.addressLine2 || "",
              city: currentClinic?.contactInfo?.city || "",
              zip: currentClinic?.contactInfo?.zip || "",
              email: currentClinic?.contactInfo?.email || "",
            },
            notes: currentClinic?.notes || "",
            methodForDrReport: (currentClinic?.methodForDrReport as ReportMethod) || "Email",
            methodForRxOrder: (currentClinic?.methodForRxOrder as ReportMethod) || "Email",
          },
        ],
      };

      // Call createDoctorWithClinic to save data
      //  setLoading(true);
      try {
        const response = await createDoctorWithClinic(createDoctorClinicDto);
        return response;
      } catch (error) {
        console.error("Error saving doctor and clinic:", error);
      } finally {
        setLoading(false);
      }
    };

    //    useEffect(() => {
    //    const inputValue = selectedBSNR || formValues?.practiceNumber
    //    const isEmpty = !inputValue || inputValue.trim() === "";

    //   if (isEmpty === false) {
    //   setIsDoctorNumberDisabled(false);
    //   }
    // }, [selectedBSNR, formValues?.practiceNumber, currentClinic?.id]);

    const renderRxComponent = () => {
      switch (formValues?.rxtype) {
        case "Privat/Selbstzahler":
          return (
            <Private
              handleNewFormData={setFormDataChange}
              newFormData={formValues!}
              patientId={patientValues.id!}
              values={patientValues}
              // therapyTableData={therapytableData}
              openRx={openDialog as boolean}
              onCloseRx={handleCloseDialog}
              entryType={patientForm ? EntryType.newRx : EntryType.additionalRx}
            />
          );
        case "Berufsgenossenschaft":
          return (
            <BG
              handleNewFormData={setFormDataChange}
              patientId={patientValues.id!}
              values={patientValues}
              newFormData={formValues}
              openRx={openDialog as boolean}
              onCloseRx={handleCloseDialog}
              entryType={patientForm ? EntryType.newRx : EntryType.additionalRx}
            />
          );
        case "Kasse":
        case "Entlassmanagement":
          return (
            <Verordnung13
              // setUnsavedChanges={handleUnsavedChanges}
              handleNewFormData={setFormDataChange}
              patientId={patientValues.id!}
              values={patientValues}
              newFormData={formValues}
              entryType={patientForm ? EntryType.newRx : EntryType.additionalRx}
              openRx={openDialog as boolean}
              onCloseRx={handleCloseDialog}
              // ref={saveGenericViewData}
            />
          );
        case "Blankoverordnung":
          return (
            <Blankoverordnung
              // setUnsavedChanges={handleUnsavedChanges}
              handleNewFormData={setFormDataChange}
              patientId={patientValues.id!}
              values={patientValues}
              newFormData={formValues}
              entryType={patientForm ? EntryType.newRx : EntryType.additionalRx}
              openRx={openDialog as boolean}
              onCloseRx={handleCloseDialog}
              // ref={saveGenericViewData}
            />
          );
        case "Bundeswehr":
          return (
            <Bundeswehr
              // setUnsavedChanges={handleUnsavedChanges}
              handleNewFormData={setFormDataChange}
              patientId={patientValues.id!}
              newFormData={formValues}
              values={patientValues}
              entryType={patientForm ? EntryType.newRx : EntryType.additionalRx}
              openRx={openDialog as boolean}
              onCloseRx={handleCloseDialog}
              // ref={saveGenericViewData}
            />
          );
        case "Zahnarzt":
          return (
            <Zahnarzt
              handleNewFormData={setFormDataChange}
              newFormData={formValues}
              patientId={patientValues.id!}
              values={patientValues}
              // setUnsavedChanges={handleUnsavedChanges}
              entryType={patientForm ? EntryType.newRx : EntryType.additionalRx}
              openRx={openDialog as boolean}
              onCloseRx={handleCloseDialog}
            />
          );
        // Add other cases for different rxtypes as needed
        default:
          return (
            <Grid container spacing={2}>
              <Grid item xs={12} lg={3} sx={{ border: "0px solid red" }}>
                <FlatCard title="Eigenschaften">
                  <Controls.Select
                    name="rxtype"
                    label="Rezept-typ"
                    // id={1}
                    value={formValues?.rxtype}
                    onChange={handleInputChange}
                    options={rxType[0]?.map((option: any) => ({
                      label: option.text.toString(),
                      value: option.text.toString(),
                      id: option.id.toString(),
                    }))}
                    // required
                    error={rxerrors.rxtype}
                  />
                  <Controls.Select
                    name="accountId"
                    label="Mandant"
                    id={1}
                    value={formValues?.accountId}
                    onChange={handleInputChange}
                    options={accounts?.map((option: any) => ({
                      label: option.name.toString(),
                      value: option.name.toString(),
                      id: option.id.toString(),
                    }))}
                    required
                    error={rxerrors.accountId}
                    // error={errors.departmentId}
                  />
                  <Controls.DatePicker
                    name="date"
                    label="Rezeptdatum"
                    value={formValues?.date}
                    onChange={handleInputChange}
                    formatDate="dd.MM.yy"
                  />
                  <Grid item xs={12}>
                    <Controls.Checkbox
                      name="isPerpetual"
                      label="Dauerrezept"
                      value={formValues?.isPerpetual}
                      onChange={handleInputChange}
                    />
                  </Grid>
                  <Controls.Select
                    name="status"
                    label="Rezeptverbleib"
                    value={formValues?.status}
                    onChange={handleInputChange}
                    options={[
                      {
                        label: "noch nicht erstellt",
                        value: "noch nicht erstellt",
                      },
                      { label: "beim Patient", value: "beim Patient" },
                      { label: "beim Therapeut", value: "beim Therapeut" },
                      { label: "vorhanden", value: "vorhanden" },
                    ]}
                    // error={errors.departmentId}
                  />
                </FlatCard>
              </Grid>
              <Grid item xs={12} lg={3}>
                <FlatCard title="Versicherung">
                  <Controls.Input
                    disabled
                    name="Receiptpayer"
                    label="Kostenträger"
                    value={selectedPayer || formValues.Receiptpayer}
                    onChange={handleInputChange}
                  />
                  <Controls.Input
                    name="chipcard"
                    label="IK der Chipkarte"
                    value={selectedChipCard || formValues?.chipcard}
                    onChange={handleInputChange}
                    onKeyDown={handleChipCardDataEntry}
                    onBlur={handleChipCardDataEntry}
                    error={rxerrors.chipcard}
                  />
                  {/* <Controls.Select
                name="Receiptpayer"
                label="Kostenträger"
                id={1}
                value={selectedPayer || formValues.Receiptpayer}
                onChange={handleInputChange}
                options={insurer[0]?.map((option: any) => ({
                  label: option?.ik.toString(),
                  value: option?.name.toString(),
                  id: option.id.toString(),
                }))}
                // required
                // error={errors.departmentId}
              />

              <Controls.Select
                name="chipcard"
                label="IK der Chipkarte"
                value={selectedChipCard || formValues?.chipcard}
                onChange={handleInputChange}
                options={insurer[0]?.map((insurer: any) => ({
                  label: insurer.name.toString(),
                  value: insurer.ik.toString(),
                }))} */}
                  {/* // required
                // error={rxerrors.chipcard}
                // error={errors.fullName} */}
                  {/* /> */}
                  <Controls.Select
                    name="tarifGroupId"
                    label="Tarif Group"
                    id={1}
                    value={formValues?.tarifGroupId}
                    onChange={handleInputChange}
                    // Only the groups the chosen Rezept-typ can be billed
                    // against, so the invariant cannot be broken by hand
                    // either. Before a type is chosen, offer all of them.
                    options={tarifGroupsForRxType?.map((value: any) => ({
                      label: value.toString(),
                      value: value.toString(),
                    }))}
                    required
                    error={rxerrors.tarifGroupId}
                  />
                  <Controls.Input
                    name="insureeNumber"
                    label="Versichertennummer"
                    value={formValues?.insureeNumber}
                    onChange={handleInputChange}
                    error={getKvnrError(formValues?.insureeNumber)}
                  />

                  <Controls.Select
                    name="insuranceStatus"
                    label="Status"
                    value={formValues?.insuranceStatus}
                    onChange={handleInputChange}
                    options={[
                      { label: "10000", value: "10000" },
                      { label: "30000", value: "30000" },
                      { label: "50000", value: "50000" },
                    ]}
                    // error={errors.departmentId}
                  />
                </FlatCard>
              </Grid>

              <Grid item xs={12} lg={3}>
                <FlatCard title="Diagnose">
                  {icdCodeEntries?.map((icdEntry: any, index: any) => (
                    <div key={`icd-${index}`}>
                      <Controls.Input
                        label={`ICD ${index + 1}`}
                        name={`icdCodeEntries-${index}`}
                        value={icdEntry.userText}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          // console.log("Eventssaa", e, index);
                          handleInputChange(e, index, icdEntry?.id);
                        }}
                        onKeyPress={(e: React.KeyboardEvent<HTMLInputElement>) => {
                          // console.log("KEY", e.key);
                          if (e.key === "Tab" || e.key === "Enter") {
                            e.preventDefault();
                            // handleICDCodeEntrySubmit(formValues.icdCodeEntries[index], index);
                            // handleICDCodeEntrySubmit(icdEntry, index);
                             setCurrentICD(icdEntry.userText);
                          }
                        }}
                        // error={errors.email}
                      />
                    </div>
                  ))}
                  <Button onClick={handleAddInput}>
                    <AddIcon />
                    ICD Hinzufügen
                  </Button>
                  <Controls.TextArea
                    name="diagnosisText"
                    rows={4}
                    placeholder="Textdiagnose"
                    value={formValues?.diagnosisText}
                    onChange={handleInputChange}
                  />
                </FlatCard>
              </Grid>
              <Grid item xs={12} lg={3}>
                <FlatCard title="Leitsymptomatik">
                  <Controls.Select
                    name="diagnosegroup"
                    label="Diagnosegruppe"
                    // id={1}
                    value={formValues?.diagnosegroup}
                    onChange={handleInputChange}
                    options={filteredDiagnoseGroups?.map((option: any) => ({
                      label: option.description.toString(),
                      value: option.code.toString(),
                      id: option.id.toString(),
                    }))}
                    // error={errors.departmentId}
                  />

                  <Controls.Checkbox
                    name="a"
                    label="a"
                    value={formValues?.a}
                    onChange={handleInputChange}
                    disabled={!selectedDiagnoseGroup?.a}
                  />
                  <Controls.Checkbox
                    name="b"
                    label="b"
                    value={formValues?.b}
                    onChange={handleInputChange}
                    disabled={!selectedDiagnoseGroup?.b}
                  />
                  <Controls.Checkbox
                    name="c"
                    label="c"
                    value={formValues?.c}
                    onChange={handleInputChange}
                    disabled={!selectedDiagnoseGroup?.c}
                  />
                  <Controls.Checkbox
                    name="d"
                    label="d"
                    value={formValues?.d}
                    onChange={handleInputChange}
                    disabled={!selectedDiagnoseGroup?.d}
                  />

                  <Controls.Checkbox
                    name="hasIndividualSymptoms"
                    label="Patientenindividuelle Leitsymptomatik"
                    value={formValues?.hasIndividualSymptoms}
                    onChange={handleInputChange}
                  />

                  <Controls.TextArea
                    name="symptoms"
                    rows={4}
                    placeholder="Patientenindividuelle Leitsymptomatik als
                  Freitext angeben"
                    value={formValues?.symptoms}
                    onChange={handleInputChange}
                  />
                </FlatCard>
              </Grid>
              <Grid item xs={12} lg={3}>
                <FlatCard
                  title="Optionen"
                  sxContent={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                    padding: 0,
                    height: "100%",
                  }}
                >
                  <Controls.Checkbox
                    name="isPerpetualApproved"
                    label="Langfristgenehmigung"
                    value={formValues?.isPerpetualApproved}
                    onChange={handleInputChange}
                  />
                  <Controls.Checkbox
                    name="isCopaymentExempted"
                    label="Zuzahlungsfrei"
                    value={formValues?.isCopaymentExempted}
                    onChange={handleInputChange}
                  />
                  <Controls.Checkbox
                    name="isAccident"
                    label="Unfallfolgen"
                    value={formValues?.isAccident}
                    onChange={handleInputChange}
                  />
                  <Controls.Checkbox
                    name="isBVG"
                    label="BVG"
                    value={formValues?.isBVG}
                    onChange={handleInputChange}
                  />
                </FlatCard>
              </Grid>
              <Grid item xs={12} lg={3}>
                <FlatCard title="Arzt & Klinik">
                  <Typography>Betriebsstätten-Nr.</Typography>
                  <Controls.Input
                    name="practiceNumber"
                    label=""
                    value={selectedBSNR || formValues?.practiceNumber}
                    onChange={handleInputChange}
                    onBlur={handlePracticeNumberInteraction}
                    onKeyDown={handlePracticeNumberInteraction}
                    style={{ width: "100%", margin: "0px" }}
                  />

                  <Typography>Arzt-Nr.</Typography>
                  <Controls.Input
                    //  disabled={
                    //   isDoctorNumberDisabled ||
                    //   creationResponse?.id != null
                    // }
                    name="doctorNumber"
                    label=""
                    value={selectedLANR || formValues?.doctorNumber || ""}
                    onChange={handleInputChange}
                    style={{ width: "100%", margin: "0px" }}
                    onBlur={handleGetDoctorById}
                    onKeyDown={handleGetDoctorById}
                  />

                  <DoctorCard
                    doctor={currentDoctor}
                    clinic={currentClinic}
                    formData={{
                      doctorNumber: formValues.doctorNumber,
                      clinic: currentClinic,
                    }}
                    showSignatureCheck={false}
                    readOnlyView={false}
                  />
                </FlatCard>
              </Grid>

              <Grid item xs={12} lg={6}>
                <FlatCard title="Behandlungen">
                  <EditTable
                    initialColumns={treatmentColumns}
                    initialRows={therapytableData}
                    onTableDataChange={handletherapyTableDataChange}
                    parseInput={handleParseInput}
                    masterTablesData={safeMasterData}
                    selectedRx={{ ...formValues, therapyType: accountTherapyType }}
                  />
                </FlatCard>
              </Grid>
              <Grid item xs={12} lg={4}>
                <FlatCard title="Anforderungen">
                  <Box style={{ width: "350px" }} flexDirection="column">
                    <Typography variant="h6">Anforderungen</Typography>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body1" sx={{ marginRight: "8px" }}>
                        Hausbesuch
                      </Typography>
                      <FormControlLabel
                        label=""
                        control={
                          <>
                            <Checkbox
                              checked={formValues.isHomeVisit === true}
                              onChange={handleCheckboxChange}
                              name="visitTypeCheckboxJa"
                              value="yes"
                            />
                            <Typography variant="body1">ja</Typography>
                            <Checkbox
                              checked={formValues.isHomeVisit === false}
                              onChange={handleCheckboxChange}
                              name="visitTypeCheckboxNein"
                              value="no"
                            />
                            <Typography variant="body1">nein</Typography>
                          </>
                        }
                      />
                    </Box>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "1px",
                      }}
                    >
                      <Controls.Checkbox
                        name="problematic"
                        label="auf Kontrolle"
                        value={formValues?.problematic}
                        onChange={handleInputChange}
                      />
                      <Controls.Checkbox
                        name="changeRequested"
                        label="auf zum Ändern"
                        value={formValues?.changeRequested}
                        onChange={handleInputChange}
                      />
                      {/* <Controls.Checkbox
                  name="booked"
                  label="abgerechnet"
                  value={formValues?.booked}
                  onChange={handleInputChange}
                /> */}

                      <Controls.Checkbox
                        name="therapyReport"
                        label="Therapiebericht"
                        value={formValues?.therapyReport}
                        onChange={handleInputChange}
                      />
                      {/* <Controls.Checkbox
                    name="homeVisit"
                    label="Haus-/Heimbesuch"
                    value={formValues?.homeVisit}
                    onChange={handleInputChange}
                  /> */}
                      {/* <Controls.Checkbox
                    name="isHomeVisitFree"
                    label="Heimbesuch zuzahlungsfrei"
                    value={formValues?.isHomeVisitFree}
                    onChange={handleInputChange}
                  /> */}
                      <Controls.Checkbox
                        name="urgent"
                        label="Dringlicher Behandlungsbedarf"
                        value={formValues?.urgent}
                        onChange={handleInputChange}
                      />
                      {/* <Controls.Checkbox
                    name="isAutoAddReport"
                    label="Berichtsposition automatisch hinzufügen"
                    value={formValues?.isAutoAddReport}
                    onChange={handleInputChange}
                  /> */}
                      <Controls.Checkbox
                        name="hygiene"
                        label="Hygieneposition automatisch hinzufügen"
                        value={formValues?.hygiene}
                        onChange={handleInputChange}
                      />
                    </div>
                  </Box>
                </FlatCard>
              </Grid>

              <Grid item xs={12} lg={4}>
                <FlatCard title="ggf. Therapieziele/weitere med. Befunde und hinweise">
                  <Controls.TextArea
                    name="additionalNotes"
                    rows={4}
                    placeholder=""
                    value={formValues?.additionalNotes}
                    onChange={handleInputChange}
                  />
                </FlatCard>
              </Grid>
              <Grid item xs={12} lg={4}>
                <FlatCard title="Arztunterschrift">
                  <Controls.RadioGroup
                    name="signatureStatus"
                    value={formValues?.signatureStatus}
                    options={[
                      { id: "nicht kontrolliert", label: "nicht kontrolliert" },
                      { id: "vorhanden", label: "vorhanden" },
                      { id: "fehlend", label: "fehlend" },
                    ]}
                    onChange={handleInputChange}
                  />
                </FlatCard>
              </Grid>
            </Grid>
          );
      }
    };

    const highlightStyle = { color: "secondary.main" };
    return (
      <Dialog maxWidth="lg" open={openDialog} onClose={handleCloseRxDialog}>
        <DialogTitle>Rezept Erstellen</DialogTitle>
        <DialogContent style={{ paddingTop: "8px" }}>
          {selectedRow && renderRxComponent()}
        </DialogContent>
        <Dialog open={showWarningDialog} onClose={handleWarningDialogClose}>
          <DialogTitle>
            Bitte wählen Sie den entsprechenden Rezept-typ aus, um fortzufahren. Wenn Sie mit der
            Standardeinstellung fortfahren möchten, klicken Sie auf "Abbrechen".
          </DialogTitle>
          <DialogContent>
            <Controls.Select
              name="rxtype"
              label="Rezept-typ"
              // id={1}
              value={formValues?.rxtype}
              onChange={(e: any) => handleRxTypeSelection(e)}
              options={rxType[0]?.map((option: any) => ({
                label: option.text.toString(),
                value: option.text.toString(),
                id: option.id.toString(),
              }))}
              // required
              error={rxerrors.rxtype}
            />
          </DialogContent>
          <DialogActions>
            <Button variant="text" onClick={handleWarningDialogClose}>
              Abbrechen
            </Button>
          </DialogActions>
        </Dialog>

        <Modal
          open={loading}
          aria-labelledby="loading-modal-title"
          aria-describedby="loading-modal-description"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div>
            <CircularProgress size={60} />
          </div>
        </Modal>
        {unsavedChangesWarning && (
          <WarningDialog
            open={true} // Ensure the warning dialog is open
            onClose={handleCloseUnsavedChangesWarning} // Function to close the dialog
            onContinue={handleUnsavedChangesWarning} // Function to continue despite unsaved changes
            title="Änderungen speichern?"
            content="Du hast einige Änderungen gemacht. Möchtest du diese speichern, bevor du schließt?"
            isConfirmSave
          />
        )}
        <DialogActions>
          <Button variant="text" onClick={handleCloseRxDialog}>
            Abbrechen
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loading || Object.values(rxerrors).some((error) => error !== "")}
            variant="contained"
          >
            Speichern
          </Button>
          <WarningDialog
            open={showWarning}
            onClose={handleCloseWarning}
            onContinue={handleContinueWarning}
            title="Achtung auf Arztunterschrift"
            content="Bitte überprüfen Sie den Unterschriftsstatus des Arztes, bevor Sie das Formular absenden."
          />
        </DialogActions>

        <VerordnungDialog
          openAddEditDialog={isClinicModalOpen}
          handleCloseAddEditDialog={() => setIsClinicModalOpen(false)}
          clinicId={currentClinicId}
          setCreationResponse={setCreationResponse}
          doctorId={currentDoctorId}
          currentClinic={currentClinic}
          // isDoctorNumberDisabled={isDoctorNumberDisabled}
        />

        <DoctorClinicJoinConfirmDialog />
        <DoctorClinicMismatchDialog />
      </Dialog>
    );
  }
);

export default ReceiptDataEntryDialog;
